module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/light-slider/light-slider.component.scss
// module id = ./src/app/features/light-slider/light-slider.component.scss
// module chunks = main